var Calendar = {};

Calendar.ShowDetailsCalendar = function(element, data, $injector) {
  Calendar.PrepareEventDescription = function(event) {
    var descr = event.description;
    if (event.description) {
      $injector.invoke([
        '$filter',
        function($filter) {
          descr = $filter('journalMarkup')(event.description);
        }
      ]);
    }
    if (event.operationId) {
      //TODO: localisation filter, note we have no localisation filter here !
      //descr= $filter('journalMarkup')(event.description);
      descr +=
        "</p><button class='btn imgHeight' style='margin-right:4px;' onclick=\"location.href='#/booking/field/" +
        event.operationId +
        '\'">' +
        i18n('fe.journals.toDocumentation', 'zur Dokumentation') +
        '</button>';
    }
    if (event.jsonNotesId) {
      descr +=
        "<button class='btn imgOnly' onclick=\"PartnerAmazone.DisplaySettingsForCalendar('" +
        event.jsonNotesId +
        "')\"><img src='img/partner/amazoneIcon.png'/></button>";
    }
    // If description would be empty, add a whitespace to make popup open anyway
    if (!descr) {
      descr = ' ';
    }

    return descr;
  };
  Calendar.EventRenderFunc = function(event, element) {
    element.qtip({
      content: {
        //text: event.description + "</p><input type=\"button\" name=\"Löschen\" onclick=\"deleteEntry(" + event._id + ")\"></input>",
        text: Calendar.PrepareEventDescription(event),
        //p><button onclick=\"deleteCalendarTask('" + event.id + "')\">Kalendereintrag löschen</button>",
        title: {
          text: event.title,
          button: true
        }
      },
      position: {
        at: 'bottom center', // Position the tooltip above the link
        my: 'top center',
        viewport: $(window), // Keep the tooltip on-screen at all times
        effect: false // Disable positioning animation
      },
      show: {
        event: 'click',
        solo: true // Only show one tooltip at a time
      },
      hide: 'unfocus',
      style: {
        classes: 'qtip-wiki qtip-light qtip-shadow'
      }
    });
  };

  setTimeout(function() {
    // Note: important to not change the original object as the calendar adds a endless loop if the object is digested by angular so we copy the object here
    var calendar_data = [];
    for (var key in data) {
      calendar_data[key] = $.extend(true, {}, data[key]);
    }

    var calendarService = $injector.get('calendarService');

    element.fullCalendar({
      header: {
        left: 'prev,next',
        center: 'title',
        right: 'month,agendaWeek'
      },
      editable: false,
      firstHour: 8,
      slotMinutes: 30,
      firstDay: 1,
      lang: calendarService.getFullCalendarLang(),
      eventRender: Calendar.EventRenderFunc,
      timezone: 'local'
    });

    $('#calendar').fullCalendar('removeEvents');
    $('#calendar').fullCalendar('addEventSource', calendar_data);

    setTimeout(function() {
      element.fullCalendar('render');
    }, 1000); // ensure calendars are correct after flip in. todo: find a better way
  }, 0);
};

global.Calendar = Calendar;
